export const FETCH_SEARCH_REQUEST = 'search/FETCH_REQUEST';
export const FETCH_SEARCH_SUCCESS = 'search/FETCH_SUCCESS';
export const FETCH_SEARCH_FAILURE = 'search/FETCH_FAILURE';
export const FETCH_CATEGORIES_REQUEST = 'search/FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'search/FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'search/FETCH_CATEGORIES_FAILURE';
export const SET_SEARCH_PARAMS = 'search/SET_PARAMS';
export const NEXT_SEARCH_PAGE = 'search/NEXT_PAGE';
export const RESET = 'search/RESET';


// WEBPACK FOOTER //
// ./src/modules/search/actionTypes.js